import {CityBean} from 'common/api/api'
import {dictionaryApi} from 'common/api/entitiesApi'
import {LabelValue, ReloadableSelector} from 'common/components/reloadable/ReloadableSelector'
import React, {FC} from 'react'

interface Props {
    onChange: (value: number[]) => void
    value?: number[]
    style?: React.CSSProperties
    disabled?: boolean
    placeholder?: string
}

export const CitySelector: FC<Props> = ({value, onChange, style, disabled, placeholder}: Props) => {
    function cityToLabelValue(city: CityBean) {
        const name = city.countryName + " / " + city.regionName + " / " + city.name
        return {value: city.id, label: name} as LabelValue<number>
    }

    function loadCities(values: number[]) {
        if (values && values.length > 0) {
            return dictionaryApi.cityGet(values).then(result => result.map(cityToLabelValue))
        } else {
            return Promise.resolve([])
        }
    }

    function searchCities(search: string, selectedValues: number[], size: number, page: number) {
        return dictionaryApi.citySearch(search, size, page, selectedValues).then(result => result.map(cityToLabelValue))
    }

    return <ReloadableSelector
        value={value}
        onChange={onChange}
        size={100}
        style={style}
        loadValues={loadCities}
        loadOptions={searchCities}
        placeholder={placeholder}
        disabled={disabled}
        errorText="Can't load cities"
        multiple
    />
}